import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { loginUser } from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Button, Dropdown, Form } from "react-bootstrap";
import hide from "../../../assets/svg/hide.png";
import EyeIcon from "../../../assets/svg/EyeIcon";
import { APP_CONST, AuthModals } from "../../../config/const";
import MumbaiSports from "../../../assets/images/icons/mumbaisports.png";
import AppButton from "../Ui/AppButton";

import Usericon from "../../../assets/images/icons/people.png";
import phoneicon from "../../../assets/images/icons/smartphone-call.png";

const LoginModal = ({ show, handleModalChange }) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const { appDetails } = useSelector((state) => state.app);
  const [isLoading, setIsLoading] = useState(false);
  const [loginMode, setLoginMode] = useState("userId");

  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = "Username cannot be empty";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const errorData = validateData();
    if (Object.keys(errorData).length) {
      return;
    }
    setIsLoading(true);
    let loginData = { ...formData };

    dispatch(
      loginUser(
        loginData,
        () => {
          setIsLoading(false);
        },
        () => {
          handleModalChange();
        },
      ),
    );
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal"}
      placement={"end"}
      keyboard={false}
      backdrop="static"
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => handleModalChange(null)}
        closeVariant="black"
      >
        {/* <Modal.Title style={{ color: "#013862" }}>Login</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <ul className="d-none">
          <li
            onClick={() => setLoginMode("userId")}
            className={loginMode === "userId" ? "active" : ""}
          >
            <div>
              <img src={Usericon} alt="Usericon" />
              <span>User ID</span>
            </div>
          </li>
          <li
            onClick={() => setLoginMode("phone")}
            className={loginMode === "phone" ? "active" : ""}
          >
            <div>
              <img src={phoneicon} alt="phoneicon" />
              <span>Phone</span>
            </div>
          </li>
        </ul>
        <div className="login-section">
          <div className="Login-rightPart">
            <div className="form-steps">
              <h2 className="h2">Login</h2>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Control
                    type="text"
                    placeholder={
                      loginMode === "userId"
                        ? "Enter Username*"
                        : "Enter phone*"
                    }
                    name="username"
                    onChange={handleChange}
                    isInvalid={!!errors.username}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.username}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password*"
                    name="password"
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((s) => !s)}
                  >
                    {showPassword ? <img src={hide} alt="" /> : <EyeIcon />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.password}
                  </Form.Control.Feedback>
                </Form.Group>
                <div className="d-flex justify-content-start mb-3">
                  <a
                    className="form-link"
                    onClick={() => {
                      handleModalChange(AuthModals.ForgotPassword);
                    }}
                    role="button"
                  >
                    Password Recovery
                  </a>
                </div>
                <AppButton
                  type="submit"
                  text="Login"
                  variant="primary"
                  isLoading={isLoading}
                />
              </Form>

              <div className="sign-up mt-4">
                Don't have an account?
                <br />
                <a
                  role="button"
                  href="#"
                  onClick={() => {
                    handleModalChange(AuthModals.Register);
                  }}
                >
                  Registration
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
